import { render, staticRenderFns } from "./PlaceholderRect.vue?vue&type=template&id=bd3d3abc&scoped=true"
import script from "./PlaceholderRect.vue?vue&type=script&lang=js"
export * from "./PlaceholderRect.vue?vue&type=script&lang=js"
import style0 from "./PlaceholderRect.vue?vue&type=style&index=0&id=bd3d3abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3d3abc",
  null
  
)

export default component.exports